const FEEDBACK_DEFAULT = {
    'like': [
        {
            'feedbackId': 'T11',
            'content': '回答准确，满足要求',
        },
        {
            'feedbackId': 'T11',
            'content': '回答优质，令人惊喜',
        },
    ],
    'dislike': [
        {
            'feedbackId': 'T11',
            'content': '有事实性错误',
        },
        {
            'feedbackId': 'T11',
            'content': '时效性差/旧闻',
        },
        {
            'feedbackId': 'T11',
            'content': '没有实际帮助',
        },
        {
            'feedbackId': 'T11',
            'content': '逻辑错误',
        },
        {
            'feedbackId': 'T11',
            'content': '没有理解问题，答非所问',
        },
        {
            'feedbackId': 'T11',
            'content': '格式错误/错乱',
        },
    ],

};

export {FEEDBACK_DEFAULT};
